import { Genre } from '../models/genre';

export class MusicalAffinitiesFiltersDto{
    genres:Genre [];
    cityId:string;
    descriptionCity:string;
}